import { useForm } from "react-hook-form";
import { Grid, TextField, Typography } from "@mui/material";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { useAppSelector } from "../../app/store/configureStore";
import { AnswersProps } from "../../app/models/Answers";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  observationForm1: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  observationForm2: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  observationForm3: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const ObservationForm: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const { user } = useAppSelector((state) => state.account);

  const defaultValues = {
    observationForm1: answersData.find(
      (answer) =>
        answer.systemCodeId === (user?.credentialTypeId === 4 ? 246 : 249)
    )?.answer,
    observationForm2: answersData.find((answer) => answer.systemCodeId === 247)
      ?.answer,
    observationForm3: answersData.find((answer) => answer.systemCodeId === 248)
      ?.answer,
  };

  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderAObservationFormCompetence = () => {
    return (
      <>
        <li>
          How do you facilitate resources to meet the needs and interests of the
          family?
        </li>
        <li>
          What practices do you use to maintain organization of records and
          documents?
        </li>
        <li>
          What strategies do you use to connect families to agencies and social
          service supports if needed?
        </li>
        <li>
          What systems do you use to conduct assessments to develop
          individualized and program plans?
        </li>
      </>
    );
  };

  return (
    <Grid container p={2} m={1} bgcolor="compV.light" mb={2}>
      {user?.credentialTypeId === 4 ? (
        <>
          <Grid item xs={12}>
            <Typography fontSize={18} fontWeight={700} mb={2}>
              CS V-a - Observation Form Use
            </Typography>
          </Grid>
          <Grid item xs={12} mb={3}>
            <Typography mb={1}>
              Write at least one paragraph that describes how you use your
              family plan, family needs assessment, individualized services
              plan, or action plan.
            </Typography>
            <ReadMoreReadLess>
              <>{renderAObservationFormCompetence()}</>
            </ReadMoreReadLess>
            <TextField
              sx={{ backgroundColor: "white" }}
              {...register("observationForm1")}
              name="observationForm1"
              label="I use my"
              fullWidth
              multiline
              rows={2}
              value={
                answersData.find((answer) => answer.systemCodeId === 246)
                  ?.answer || ""
              }
              onChange={(e) => {
                const newValue = e.target.value;
                const systemCodeId = 246;

                newValue.length <= 500 &&
                  onAnswerChange(systemCodeId, newValue);
              }}
              error={!!errors.observationForm1?.message}
              helperText={errors.observationForm1?.message}
            />
            <Typography fontSize={13}>
              {defaultValues.observationForm1?.length}/500
            </Typography>
          </Grid>
          <Grid item xs={12} mb={3}>
            <Typography mb={1}>
              Why is developing plans for families an important part of program
              management?
            </Typography>

            <TextField
              sx={{ backgroundColor: "white" }}
              {...register("observationForm2")}
              name="observationForm2"
              label="Developing plans for families is an important part of program management because"
              fullWidth
              multiline
              rows={2}
              value={
                answersData.find((answer) => answer.systemCodeId === 247)
                  ?.answer || ""
              }
              onChange={(e) => {
                const newValue = e.target.value;
                const systemCodeId = 247;

                newValue.length <= 500 &&
                  onAnswerChange(systemCodeId, newValue);
              }}
              error={!!errors.observationForm2?.message}
              helperText={errors.observationForm2?.message}
            />
            <Typography fontSize={13}>
              {defaultValues.observationForm2?.length}/500
            </Typography>
          </Grid>
          <Grid item xs={12} mb={3}>
            <Typography mb={1}>
              How do you ensure you are accurately using the plan to evaluate
              the family`s learning progress?
            </Typography>

            <TextField
              sx={{ backgroundColor: "white" }}
              {...register("observationForm3")}
              name="observationForm3"
              label="I ensure I am accurately using the plan to evaluate the family`s learning progress by"
              fullWidth
              multiline
              rows={2}
              value={
                answersData.find((answer) => answer.systemCodeId === 248)
                  ?.answer || ""
              }
              onChange={(e) => {
                const newValue = e.target.value;
                const systemCodeId = 248;

                newValue.length <= 500 &&
                  onAnswerChange(systemCodeId, newValue);
              }}
              error={!!errors.observationForm3?.message}
              helperText={errors.observationForm3?.message}
            />
            <Typography fontSize={13}>
              {defaultValues.observationForm3?.length}/500
            </Typography>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12}>
            <Typography fontSize={18} fontWeight={700}>
              CS V-a - Observation Form Use{" "}
            </Typography>
            <Typography>
              How have you used the observation tool/form that you included in
              Resource Collection V?
            </Typography>
            <TextField
              sx={{ backgroundColor: "white" }}
              {...register("observationForm1")}
              name="observationForm1"
              label="I used the observation tool/form to"
              fullWidth
              multiline
              rows={2}
              value={
                answersData.find((answer) => answer.systemCodeId === 249)
                  ?.answer || ""
              }
              onChange={(e) => {
                const newValue = e.target.value;
                const systemCodeId = 249;

                newValue.length <= 500 &&
                  onAnswerChange(systemCodeId, newValue);
              }}
              error={!!errors.observationForm1?.message}
              helperText={errors.observationForm1?.message}
            />
            <Typography fontSize={13}>
              {defaultValues.observationForm1?.length}/500
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};
export default ObservationForm;
